import { isDockerEnv } from '../environment';

export function apiHost(): string {
  if (!isDockerEnv()) {
    return 'http://localhost:3000';
  }
  return process.env.NEXT_PUBLIC_REACT_APP_API_HOST!;
}
